/**
 * @generated SignedSource<<a656cd9c7e263d06196d730514201dc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItemBadge_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_seller">;
  readonly " $fragmentType": "NavItemBadge_seller";
};
export type NavItemBadge_seller$key = {
  readonly " $data"?: NavItemBadge_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItemBadge_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItemBadge_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNotificationsConfig_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "c9ff349a761800ac6e68b1aa7e6d07fa";

export default node;
